import { For, Show } from "solid-js";
import type { RealtimeStats } from "../types";

export function RealtimeStatsCards(props: { stats: RealtimeStats | null }) {
  return (
    <Show when={props.stats}>
      <div class="flex gap-4">
        <div class="bg-gray-900 border border-gray-800 rounded-lg px-4 py-3 flex-1">
          <div class="text-xs text-gray-500">Connections</div>
          <div class="text-2xl font-bold text-gray-200">{props.stats!.totalConnections}</div>
        </div>
        <For each={Object.entries(props.stats!.byRole)}>
          {([role, count]) => (
            <div class="bg-gray-900 border border-gray-800 rounded-lg px-4 py-3 flex-1">
              <div class="text-xs text-gray-500">{role}</div>
              <div class="text-2xl font-bold text-gray-200">{count}</div>
            </div>
          )}
        </For>
      </div>
    </Show>
  );
}
